<mat-form-field appearance="outline" class="w-100 no-valid">
    <input 
    (focusout)="onFocusOutEvent($event)"
    (ngModelChange)="addressChange()"
    [(ngModel)]="address" id="inputAddress" #mapSearchField placeholder="Escribe tu dirección... "
        matInput type="text">

    <button *ngIf="showSearchButton"
    (click)="searchLocation()"
    matSuffix mat-icon-button aria-label="Clear">
        <mat-icon>search</mat-icon>
    </button>
    <button class="explore-button cp" (click)="getCurrentLocation()" matPrefix mat-icon-button
        aria-label="Clear">
        <mat-icon>explore</mat-icon>
    </button>
</mat-form-field>